<ndt-report-header-bar
  [showDownloadOptions]="showReportOutput"
  [reportName]="name"
  [allowExcel]="allowExcel"
  [allowHtml]="allowHtml"
  [allowPdf]="allowPdf"
  [allowMemorize]="allowMemorize"
  [pageType]="pageType"
  (downloadExcel)="onDownloadExcel()"
  (downloadPdf)="onDownloadPdf()"
  (downloadHtml)="onDownloadHtml()"
  (configure)="onConfigure()"
  (saveParameters)="onSaveParameters()"
></ndt-report-header-bar>

@if (showReportOutput) {
  <div class="report-content-container">
    <ng-content select="[ndtReportOutput]"></ng-content>
    <!-- <ng-content select="[qmgDynamicReportOutput]"></ng-content> -->
  </div>
}

@if (!showReportOutput && showNoReportDataFound) {
  <div class="no-report-data">
    <div>
      <h4 class="no-report-data-header">No report data found</h4>
      <div class="flex-container justify-content-center">
        <button mat-raised-button type="button" (click)="onConfigure()">Configure Report</button>
      </div>
      <!-- TODO: QMG-2332 The report list page was temporarily removed -->
      <!-- <a mat-stroked-button [routerLink]="['/reports']">Reports Menu</a> -->
    </div>
  </div>
}
